import React, { useLayoutEffect, useState } from 'react';
import { Link } from 'react-router-dom';


const Header = React.memo(() => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);


  useLayoutEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  return (
    <div
      className={`fixed top-0 left-0 w-full z-10 ${isScrolled ? 'bg-customGray' : 'bg-gray-800'}`}

    >
      {/* Header container */}
      <header className="h-24 mx-auto p-4 pb-8 pt-2 md:pt-4 sticky top-0 z-10 transition duration-500 flex justify-between items-center">
        {/* Logo image */}
        <div className="logo pl-4">
          <img src="/logo-png.png" alt="Stelzl Logo" className="w-20 md:w-24 rounded-md" loading="eager" decoding="async" />
        </div>
        {/* Nav links */}
        <div className="hidden md:flex justify-between items-center">
          <nav className="flex items-center justify-center">
            <ul className="flex justify-center space-x-4 sm:space-x-6 md:space-x-8 lg:space-x-10">
              <li>
                <Link to="/home" className="text-white py-2 px-4 text-lg header hover:underline">Home</Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-white py-2 px-4 text-lg header hover:underline">Showcase</Link>
              </li>
              <li>
                <Link to="/contact" className="text-white py-2 px-4 text-lg header hover:underline">Contact</Link>
              </li>
            </ul>
          </nav>
        </div>
        {/* Hamburger menu*/}
        <div className="md:hidden flex justify-between items-center">
          <div className="hamburger-menu pr-4 relative z-10">
            <button className="md:hidden hamburger-menu-button" onClick={toggleMenu}>
              <svg className="h-8 w-8" fill="none" stroke="white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
            {isMenuOpen && (
              <div className="fixed top-0 left-0 h-screen w-screen bg-black p-8 z-[9999] flex flex-col justify-center items-center" style={{zIndex: 9999}}>
                <button className="absolute top-4 right-4 p-2" onClick={toggleMenu}>
                  <svg className="h-6 w-6 text-white" fill="none" stroke="white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>

                {/* Mobile menu links */}
                  <ul className="flex flex-col space-y-8 text-center">
                    <li>
                      <Link to="/home" className="text-white py-6 px-8 text-3xl font-semibold hover:underline" onClick={toggleMenu}>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/portfolio" className="text-white py-6 px-8 text-3xl font-semibold hover:underline" onClick={toggleMenu}>
                        Showcase
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" className="text-white py-6 px-8 text-3xl font-semibold hover:underline" onClick={toggleMenu}>
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              
            )}
          </div>
        </div>
      </header>
    </div>

  );
});

Header.displayName = 'Header';

export default Header;